/* eslint-disable */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export type EditAttendanceRecordPayload = {
  punchInTime?: string;   // ISO 8601 datetime string
  punchOutTime?: string;  // ISO 8601 datetime string
  status?: "Present" | "Absent";
  isHalfDay?: boolean;
  notes?: string;
};

export type EditAttendanceRecordResponse = {
  success: boolean;
  message?: string;
  data?: {
    record: any;
    activity: any | null;
    updatedBy: {
      userId: string;
      name: string;
      role: string;
    };
  };
};

export const editAttendanceRecordRequest = async (
  recordId: string,
  payload: EditAttendanceRecordPayload
): Promise<EditAttendanceRecordResponse> =>
  (
    await customAxios.put<EditAttendanceRecordResponse>(
      `/attendance/edit-record/${recordId}`,
      payload
    )
  ).data;

export const useEditAttendanceRecord = () => {
  const queryClient = useQueryClient();

  return useMutation<
    EditAttendanceRecordResponse,
    AxiosError,
    { recordId: string; payload: EditAttendanceRecordPayload }
  >(
    ({ recordId, payload }) => editAttendanceRecordRequest(recordId, payload),
    {
      onSuccess: (res) => {
        showNotification({
          title: "Attendance Updated",
          message: res.message ?? "Attendance record updated successfully.",
          color: "green",
        });

        queryClient.invalidateQueries(["admin-attendance-list"]);
        queryClient.invalidateQueries(["attendanceAdminList"]);
        queryClient.invalidateQueries(["attendance"]);
      },
      onError: (error) => {
        showNotification({
          title: "Error Updating Attendance",
          message:
            (error.response?.data as { message?: string })?.message ??
            error.message ??
            "Failed to update attendance record",
          color: "red",
        });
      },
      retry: 1,
    }
  );
};
